import 'utils/serialize_object';
import AjaxComponentLoader from 'utils/ajax_component_loader';
import ModalManager from 'utils/modal_manager';
import { handleApiError } from 'utils/api_error_handler';

(function ($) {
  'use strict';
  const $filterForm = $('.js-filter-form');

  function handleCreateErrors(response) {
    const message = response?.errors
      ? Object.values(response.errors)[0][0]
      : null;

    if (
      message === 'O nome do caderno deve ter, no mínimo, 3 caracteres' ||
      message === 'Você já possui um caderno com este nome' ||
      message === 'Por favor, informe um nome para o caderno'
    ) {
      toastr.error(message);
    } else {
      handleApiError(message, response);
    }
  }

  $filterForm.on('click', '.js-btn-generate-notebook', () => {
    const serialized = $filterForm.serializeObject();
    const product = $('.js-btn-generate-notebook').data().productKey;

    AjaxComponentLoader.load({
      component: 'modals/filter_generate_notebook_modal',
      type: 'component',
      data: {
        product_key: product,
        filter: serialized
      }
    }).then(html => {
      ModalManager.open(html, (formData, $formEvent) => {
        const name = $formEvent.find('[name="notebook-name"]').val();
        const $modal = $('#js-filter-generate-notebook');
        const limit = $modal.data().questionsLimit;
        const data = {
          product: product,
          source_project: 1,
          questions_limit: limit,
          populated: true,
          notebook: {
            name: name,
            filter: serialized
          }
        };

        Thor.Notebook.create({}, { data: data })
          .then(() => {
            toastr.success('Caderno criado com sucesso!');
            $modal.remove();
          })
          .catch(async ({ response }) => {
            handleCreateErrors(await response.json());
          });
      });
    });
  });
})(jQuery);
